<template>
  <div class="main">
    <div class="left" v-if="!isContrast">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- 轮播块 -->
        <swiper-slide v-for="item in imageList" :key="item">
          <img v-if="item.includes('.jpg') || item.includes('.png')" :src="item" />
          <video v-else-if="item.includes('.mp4') && !isContrast" width="1200" height="700 " controls :src="item"
            :id="item"></video>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev" @click="onPrev"></div>
        <div class="swiper-button-next" slot="button-next" @click="onNext"></div>
      </swiper>
      <div class="add-button">
        <!-- <el-dropdown @command="changeImgLevel" v-if="!getFinishReport">
          <el-button v-if="imgLevel == 0" style="color: #00CDCD; font-weight: bold">未质审<i
              class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-button v-if="imgLevel == 1" style="color: #CD853F; font-weight: bold">质控不合格<i
              class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-button v-if="imgLevel == 2" style="color: #8B475D; font-weight: bold">质控合格<i
              class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-button v-if="imgLevel == 3" style="color: #8B475D; font-weight: bold">高质量图片<i
              class="el-icon-arrow-down el-icon--right"></i></el-button> -->
          <!-- <el-button v-if="imgLevel == 4" style="color: #8B475D; font-weight: bold">均匀等回声斑块<i class="el-icon-arrow-down el-icon--right"></i></el-button> -->
          <!-- <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="imgLevel != 0" command="0">未质审</el-dropdown-item>
            <el-dropdown-item v-if="imgLevel != 1" command="1">质量不合格</el-dropdown-item>
            <el-dropdown-item v-if="imgLevel != 2" command="2">质量合格</el-dropdown-item>
            <el-dropdown-item v-if="imgLevel != 4" command="4">均匀等回声斑块</el-dropdown-item>
            <el-dropdown-item v-if="imgLevel != 3" command="3">高质量图片</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <!-- <el-button @click="handleImage()" size="middle" type="primary" v-if="getIsEdit">添加</el-button> -->
    <el-radio-group  @change="changeImgLevel" v-if="!getFinishReport" v-model="imgLevel" size="small">
      <el-radio-button label= "0" >未质控</el-radio-button>
      <el-radio-button label= "1" >质控不合格</el-radio-button>
      <el-radio-button label= "2" >质控合格</el-radio-button>
      <el-radio-button label= "3" >高质量图片</el-radio-button>
    </el-radio-group>         
      </div>
    </div>
    <div class="contrast-swiper-box" v-else>
      <div class="swiper-left-box">
        <el-carousel height="875px" :autoplay="false" indicator-position="outside">
          <el-carousel-item v-for="item in imageList" :key="item">
            <img style="width: 100%;object-fit: contain;" v-if="item.includes('.jpg') || item.includes('.png')" :src="item" />
            <video v-else-if="item.includes('.mp4')" width="600" height="750" controls :src="item" :id="item"></video>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="swiper-right-box">
        <el-carousel height="875px" :autoplay="false" indicator-position="outside">
          <el-carousel-item v-for="item in contrastImg" :key="item">
            <img style="width: 100%;object-fit: contain;" v-if="item.includes('.jpg') || item.includes('.png')" :src="item" />
            <video v-else-if="item.includes('.mp4')" width="600" height="750" controls :src="item" :id="item"></video>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="right">
      <div class="right-title">
        <div class="title-left" @click="backToHome">
          <i class="el-icon-back" />退出
        </div>
        <span class="title"></span>
        <div class="title-right" v-if="!getFinishReport">
          <el-dropdown @command="changeQC">
            <el-button v-if="isQC === 1" style="color: #00CDCD; font-weight: bold">一级<i
                class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-button v-else-if="isQC === 2" style="color: #CD853F; font-weight: bold">二级<i
                class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-button v-else-if="isQC === 3" style="color: #8B475D; font-weight: bold">三级<i
                class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-button v-else-if="isQC === -1" style="color: #0091ea; font-weight: bold">待质控<i
                class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-button v-else style="color: #84bf96; font-weight: bold">正常<i
                class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="isQC != -1" command="-1">待质控</el-dropdown-item>
              <el-dropdown-item v-if="isQC != 0" command="0">正常</el-dropdown-item>
              <el-dropdown-item v-if="isQC != 1" command="1">一级</el-dropdown-item>
              <el-dropdown-item v-if="isQC != 2" command="2">二级</el-dropdown-item>
              <el-dropdown-item v-if="isQC != 3" command="3">三级</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="changePrescribe" size="small">
            <el-button v-if="isChange === 0" style="color: #00CDCD; font-weight: bold">未质控<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-button v-else-if="isChange === 1" style="color: #CD853F; font-weight: bold">已质控<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="isChange != 0" command="0">未质控</el-dropdown-item>
            <el-dropdown-item v-if="isChange != 1"command="1">已质控</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="right-box">
        <p class="title">患者信息</p>
        <span class="patient-msg">订单：{{ this.orderSn }}</span>
        <span class="patient-msg">病例质控总评分：{{ (this.imgPassRate * 100).toFixed(0) }}%</span>
        <span class="patient-msg">姓名：{{ patientInfo.name }}</span>
        <span class="patient-msg">性别：{{ patientInfo.sex }}</span>
        <span class="patient-msg">年龄：{{ patientInfo.age }}</span>
        <span class="patient-msg">科室：{{ patientInfo.departmentName }}</span>
        <span class="patient-msg">部位：{{ patientInfo.presetName }}</span>
        <span class="patient-msg" v-show="isShowMore">当前图片质控评分：{{ (this.qcScore*100).toFixed(0) }}%</span>
        <span class="patient-msg" v-show="isShowMore">斑块厚度：{{ this.plaqueThickness.toFixed(2) }}mm</span>
        <span class="patient-msg" v-show="isShowMore">斑块长径：{{ this.plaqueLength.toFixed(2) }}mm</span>
        <span class="patient-msg" v-show="isShowMore">血管直径：{{ this.carotidDiameter.toFixed(2) }}mm</span>
        <span class="patient-msg" v-show="isShowMore">斑块宽度：{{ this.plaqueWidth.toFixed(2) }}mm</span>
        <span class="patient-msg" v-show="isShowMore">斑块面积：{{ this.plaqueArea.toFixed(2) }}mm²</span>
        <span class="patient-msg" v-show="isShowMore">ECST狭窄比：{{ (this.plaqueRate*100).toFixed(0) }}%</span>
        <span class="patient-msg" v-show="isShowMore">面积狭窄比：{{ this.areaRate.toFixed(0) }}%</span>
        <span class="patient-msg" v-show="isShowMore">甘油三酯：{{ getTg }}</span>
        <span class="patient-msg" v-show="isShowMore">总胆固醇：{{ getTc }}</span>
        <span class="patient-msg" v-show="isShowMore">低密度脂蛋白胆固醇：{{ getldlC }}</span>
        <span class="patient-msg" v-show="isShowMore">高密度脂蛋白胆固醇：{{ gethdlC }}</span>
        <span class="patient-msg" v-show="isShowMore">高血压：{{ getHighBlood }}</span>
        <span class="patient-msg" v-show="isShowMore">糖尿病：{{ getDiabetes }}</span>
        <span class="patient-msg" v-show="isShowMore">高脂血症：{{ getHlp }}</span>
        <span class="patient-msg" v-show="isShowMore">5年吸烟史：{{ getSmoke }}</span>
        <span class="patient-msg" v-show="isShowMore">中风史：{{ getStroke }}</span>
        <span class="patient-msg" v-show="isShowMore">心梗病史：{{ getMI }}</span>
        <span class="more-msg" @click="showMore">{{ getMoreTitle }}</span>
      </div>
      <div class="right-box-img">
        <div class="right-box-title">
          <span class="title">上传报告</span>
        </div>
        <el-upload class="upload-demo" ref="upload"
          action="https://yunying.server.storkhealthcare.cn/service-order/report/uploadReport" name="pdfFile"
          :on-remove="handleRemove" :on-change="handlChange" :on-exceed="handlExceed" :on-success="fileUploadSuccess"
          :on-error="fileUploadError" :file-list="fileList" :limit="1" accept=".pdf" :data="uploadData"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="success" v-if="getIsEdit">选取文件</el-button>
          <el-button @click="sendPdf" size="small" type="primary" v-if="getIsEdit">上传报告</el-button>
          <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
        </el-upload>
      </div>
      <div class="right-box-img">
        <div class="right-box-title">
          <span class="title">上传3D图片</span>
        </div>
        <el-upload class="upload-demo" ref="Imgupload"
          action="https://yunying.server.storkhealthcare.cn/service-order/report/upload3DImg" name="imgFile"
          :on-remove="handleImgRemove" :on-change="handlImgChange" :on-exceed="handlExceed" :on-success="fileUploadSuccess"
          :on-error="fileUploadError" :file-list="imgfileList" :limit="1" accept=".zip" :data="uploadData"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="success" v-if="getIsEdit">选取文件</el-button>
          <el-button @click="sendImg" size="small" type="primary" v-if="getIsEdit">上传报告</el-button>
          <div slot="tip" class="el-upload__tip">只能上传zip文件</div>
        </el-upload>
      </div>
      <!-- <div class="right-box-img">
        <div class="right-box-title">
          <span class="title">图像选择</span>
          <span class="el-radio" @click="clearImages" v-if="getIsEdit">清空</span>
        </div>
        <div class="imageDisplay">
          <ul>
            <li v-for="(item, index) in selectedList" :key="index">
              <img :src="item"/>
              <i class="el-icon-circle-close" @click="deleteCurrentImage(item, index)"/>
            </li>
          </ul>
        </div>
      </div>
      <div class="right-box-record">
        <div class="right-box-title">
          <span class="title">影像学表现</span>
        </div>
        <el-input
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 10 }"
          placeholder="请输入内容"
          v-model="reportInfo.image_performance"
          :disabled="getIsPreView">
        </el-input>
      </div>-->
      <div class="right-box-record">
        <div class="right-box-title">
          <span class="title">图片诊断结论</span>
        </div>
        <el-input
          type="textarea"
          :rows="5"
          :autosize="{ minRows: 2, maxRows: 10 }"
          placeholder="请输入内容"
          v-model="description"
          :disabled="getIsPreView">
        </el-input>
        <el-button  class="refund-btn" type="info" size="small" @click="changeImgDescription"  v-if="getIsEdit">上传诊断结论</el-button>
      </div> 
      <div class="history-list" v-if="historyList.length">
        <div class="history-list-box" v-for="(item, index) in historyList" :key="index">
          <div class="history-left-box">
            <div class="item-name">订单：{{ item.name }} {{ item.phone_num }}</div>
            <div class="item-date">{{ item.date_Time }}</div>
          </div>
          <div v-if="!isContrast" class="history-right-box" @click="onContrast(item)">
            对比
          </div>
          <div v-else-if="isContrast && contrastId==item.order_sn" class="history-right-close" @click="onCloseContrast">
            取消对比
          </div>
        </div>
      </div>
      <div class="right-button">
        <div class="button-two">
          <el-button @click="refundOrder" size="middle" type="danger" v-if="getIsEdit">报告退还</el-button>
          <el-button @click="transOrder" size="middle" type="success" v-if="getIsEdit">报告转审</el-button>
          <el-button @click="sendReport" size="middle" type="primary" v-if="getIsEdit">完成病历</el-button>
          <el-button @click="getOrder" size="middle" type="primary" v-if="!getFinishReport && !getIsEdit">接单</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  changeImgPlaqueLevel,
  controllerOrder,
  getImgPlaqueLevel,
  getOrderDetail,
  uploadReport,
  getOrder,
  transOrder,
  uploadPdf,
  getOrderList,
  changePrescribe,
  changeImgDescription,
  refundOrder
} from '../../request/api'
import JsUtill from '../utils/JsUtill'
export default {
  name: 'EditReport',
  props: ['orderSn', 'departmentList', 'presetList', 'isEdit', 'isFinish'],
  mounted() {
    if (this.departmentList && this.presetList) {
      sessionStorage.setItem("departmentList", JSON.stringify(this.departmentList))
      sessionStorage.setItem("presetList", JSON.stringify(this.presetList))
    }
    this.nowIsEdit = this.isEdit
    this.finishReport = this.isFinish != null
    let that = this
    getOrderDetail({
      order_sn: that.orderSn
    }).then(response => {
      if (response.code === 1000) {
        that.orderInfo = response.data
        this.getHistoryOrderList()
        that.patientInfo.name = response.data.name
        if (response.data.sex === 0) {
          that.patientInfo.sex = '女'
        } else {
          that.patientInfo.sex = '男'
        }
        that.patientInfo.age = response.data.age
        that.orderType = response.data.type
        that.isChange = response.data.isChange
        that.imgPassRate = response.data.imgPassRate
      } else {
        this.$message.error('请求数据失败')
      }
      if (!that.departmentList) {
        that.departmentList = JSON.parse(sessionStorage.getItem("departmentList"))
      }
      if (!that.presetList) {
        that.presetList = JSON.parse(sessionStorage.getItem("presetList"))
      }
      for (let item of that.departmentList) {
        if (item.value === response.data.department_id) {
          that.patientInfo.departmentName = item.label
        }
      }
      for (let item of that.presetList) {
        if (item.value === response.data.preset_id) {
          that.patientInfo.presetName = item.label
        }
      }
      that.imageList = response.data.image_url.split(',')
      for (let i = 0; i < that.imageList.length; i++) {
        if (that.imageList[i] === '' || that.imageList[i].indexOf('zip') !== -1 || that.imageList[i].indexOf('txt') !== -1) {
          that.imageList.splice(i, 1)
          i--
        }
      }
      that.getCurImgPlaqueLevel(that)
    })
  },
  computed: {
    getIsPreView() {
      return this.nowIsEdit === false
    },
    getIsEdit() {
      return this.nowIsEdit
    },
    getFinishReport() {
      return this.finishReport
    },
    getPlaque() {
      if (this.orderInfo === null || this.orderInfo.plaqueThickness === -1) {
        return '无数据'
      } else {
        return (this.orderInfo.plaqueThickness).toFixed(2) + 'mm'
      }
    },
    getCarotid() {
      if (this.orderInfo === null || this.orderInfo.carotidDiameter === -1) {
        return '无数据'
      } else {
        return (this.orderInfo.carotidDiameter).toFixed(2) + 'mm'
      }
    },
    getPlaqueRate() {
      if (this.orderInfo === null || this.orderInfo.plaqueThickness === -1 || this.orderInfo.carotidDiameter === -1) {
        return '无数据'
      } else {
        return ((this.orderInfo.plaqueThickness / this.orderInfo.carotidDiameter) * 100).toFixed(0) + '%'
      }
    },
    getTg() {
      if (this.orderInfo === null || this.orderInfo.tg === -1) {
        return '无数据'
      } else {
        return this.orderInfo.tg
      }
    },
    getTc() {
      if (this.orderInfo === null || this.orderInfo.tc === -1) {
        return '无数据'
      } else {
        return this.orderInfo.tc
      }
    },
    getldlC() {
      if (this.orderInfo === null || this.orderInfo.ldlC === -1) {
        return '无数据'
      } else {
        return this.orderInfo.ldlC
      }
    },
    gethdlC() {
      if (this.orderInfo === null || this.orderInfo.ldlC === -1) {
        return '无数据'
      } else {
        return this.orderInfo.hdlC
      }
    },
    getHighBlood() {
      if (this.orderInfo === null) {
        return '无数据'
      } else if (this.orderInfo.highBlood === 0) {
        return '否'
      } else {
        return '是'
      }
    },
    getSmoke() {
      if (this.orderInfo === null) {
        return '无数据'
      } else if (this.orderInfo.smoke === 0) {
        return '否'
      } else {
        return '是'
      }
    },
    getDiabetes() {
      if (this.orderInfo === null) {
        return '无数据'
      } else if (this.orderInfo.diabetes === 0) {
        return '否'
      } else {
        return '是'
      }
    },
    getHlp() {
      if (this.orderInfo === null) {
        return '无数据'
      } else if (this.orderInfo.hlp === 0) {
        return '否'
      } else {
        return '是'
      }
    },
    getStroke() {
      if (this.orderInfo === null) {
        return '无数据'
      } else if (this.orderInfo.stroke === 0) {
        return '否'
      } else {
        return '是'
      }
    },
    getMI() {
      if (this.orderInfo === null) {
        return '无数据'
      } else if (this.orderInfo.mi === 0) {
        return '否'
      } else {
        return '是'
      }
    },
    getMoreTitle() {
      if (this.isShowMore) {
        return '收起'
      } else {
        return '更多信息'
      }
    }
  },
  data() {
    return {
      orderInfo: null,
      checked: true,
      patientInfo: {
        name: '',
        sex: '',
        age: '',
        departmentName: '',
        presetName: ''
      },
      orderType: 0,
      imageList: [],
      selectedList: [],
      currentImageIndex: 0,
      reportInfo: {
        image_conclusion: '0',
        image_performance: '0',
        order_sn: this.orderSn
      },
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: false,
        centeredSlides: true,
        on: {
          slideChangeTransitionEnd: () => {
            this.currentImageIndex = this.$refs.mySwiper.swiper.activeIndex
            this.getCurImgPlaqueLevel(this)
          }
        }
      },
      nowIsEdit: null,
      finishReport: false,
      imgLevel: 0,
      isQC: 0,
      isShowMore: false,
      isChange: 0,
      imgPassRate : 0,
      description : '',
      //提交Loading
      submitLoading: false,
      fileList: [],
      imgfileList:[],
      uploadData: { orderSn: this.orderSn },
      historyList: [], // 历史订单
      contrastImg: [], // 对比图片列表
      contrastId: null, //对比列表ID
      isContrast: false, // 是否对比
      plaqueThickness: 0.0,//斑块厚度
      carotidDiameter: 0.0,//颈动脉直径
      plaqueWidth: 0.0,//斑块宽度
      plaqueArea: 0.0,//斑块面积
      plaqueRate: 0.0, //狭窄比
      plaqueLength:0.0, //斑块长径
      areaRate:0.0,//斑块面积比
      qcScore:0.0
    }
  },
  methods: {
    // 取消对比
    onCloseContrast(){
      this.isContrast = false;
      this.contrastId = null;
    },
    // 点击对比
    onContrast(val) {
      this.contrastImg = val.image_url.split(",");
      this.isContrast = true;
      this.contrastId = val.order_sn
    },
    // 获取历史列表
    getHistoryOrderList() {
      let body = {
        departmentId: this.orderInfo.department_id,
        pageNum: 1,
        pageSize: 20,
        type: 0,
        presetId: this.orderInfo.preset_id,
        hospitalId: this.orderInfo.hospital_id,
        durationStart: 0,
        durationEnd: new Date().getTime(),
        isAll: 1,
        normal: 0,
        inputSearch: this.orderInfo.name,
        qc1: 0,
        qc2: 0,
        qc3: 0,
        qc0: 0,
        orderYunyingType: 0,
        expertId: this.orderInfo.tech_id,
        orderSn: this.orderInfo.order_sn,
        phoneNum:this.orderInfo.phone_num
      }
      getOrderList(body).then(res => {
        if (res.code == 1000) {
          res.data.data.forEach(item => {
            item.date_Time = JsUtill.methods.getTime(item.create_date)
          })
          this.historyList = res.data.data
        }
      })
    },
    onPrev() {
      let that = this
      this.imageList.forEach(item => {
        if (item.includes('.mp4')) {
          let videoDom = document.getElementById(item)
          videoDom.pause()
        }
      });
    },
    onNext() {
      let that = this
      this.imageList.forEach(item => {
        if (item.includes('.mp4')) {
          let videoDom = document.getElementById(item)
          videoDom.pause()
        }
      });
    },
    changeQC(val) {
      let that = this
      controllerOrder([{
        orderSn: that.orderSn,
        orderLevel: val,
        userType: 4
      }]).then((resp) => {
        if (resp.code === 1000) {
          that.getCurImgPlaqueLevel(that)
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    changePrescribe (val) {
      let that = this
      changePrescribe({
        orderSn: that.orderSn,
      }).then((resp) => {
        if (resp.code === 1000) {
          getOrderDetail({
              order_sn: that.orderSn
            }).then(response => {
              if (response.code === 1000) {
                that.isChange = response.data.isChange
              } else {
                this.$message.error('请求数据失败')
              }
            })
        } else {
          that.$message.error(resp.msg)
        }
      })
    },
    getCurImgPlaqueLevel(that) {
      getImgPlaqueLevel({
        imageUrl: that.imageList[that.currentImageIndex]
      }).then(response => {
        if (response.code === 1000) {
          if (response.data != null) {
            that.imgLevel = response.data.plaqueLevel
            that.isQC = response.data.qcLevel
            that.imgPassRate = response.data.imgPassRate
            that.description = response.data.description
            that.plaqueThickness = response.data.plaqueThickness
            that.carotidDiameter = response.data.carotidDiameter
            that.plaqueWidth = response.data.plaqueWidth
            that.plaqueArea = response.data.plaqueArea
            that.plaqueRate = (response.data.plaqueThickness/response.data.carotidDiameter|| 0)
            that.plaqueLength = response.data.plaqueLength
            that.areaRate = response.data.areaRate
            if(that.areaRate == -1){
              that.areaRate = 0
            }
            that.qcScore = response.data.qcScore
          } else {
            that.imgLevel = 2
            getOrderDetail({
              order_sn: that.orderSn
            }).then(response => {
              if (response.code === 1000) {
                that.isQC = response.data.isQC
                that.isChange = response.data.isChange
                that.imgPassRate = response.data.imgPassRate
                that.description = response.data.description
                that.plaqueThickness = 0.00
                that.carotidDiameter = 0.00
                that.plaqueArea = 0.00
                that.plaqueWidth = 0.00
                that.plaqueRate = 0.00
                that.plaqueLength = 0.00
                that.areaRate = 0.00
                that.qcScore = 0.00
              } else {
                this.$message.error('请求数据失败')
              }
            })
          }
        } else {
          that.$message.error('请求数据失败')
        }
      })
    },
    changeImgLevel(value) {
      let that = this
      changeImgPlaqueLevel({
        orderSn: that.orderSn,
        imageUrl: that.imageList[that.currentImageIndex],
        plaqueLevel: value
      }).then(resp => {
        let data = resp
        if (data.code === 1000) {
          that.getCurImgPlaqueLevel(that)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    changeImgDescription(value) {
      let that = this
      changeImgDescription({
        imageUrl: that.imageList[that.currentImageIndex],
        description: that.description
      }).then(resp => {
        let data = resp
        if (data.code === 1000) {
          that.getCurImgPlaqueLevel(that)
          this.$message.success('已修改结论')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    backToHome() {
      this.$confirm('退出之后编辑的内容将被清空, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.getIsPreView && !this.finishReport) {
          this.$router.push({ 'name': 'Home', params: { type: 0 } })
          return
        } else if (this.finishReport) {
          this.$router.push({ 'name': 'Home', params: { type: 2 } })
          return
        }
        this.$router.push({ 'name': 'Home', params: { type: 1 } })
      }).catch(() => {
      })
    },
    handleImage() {
      let isSelected = false
      for (let item of this.selectedList) {
        if (item === this.imageList[this.currentImageIndex]) {
          isSelected = true
        }
      }
      if (isSelected) {
        this.$message.warning('该图片已经添加')
      } else {
        this.selectedList.push(this.imageList[this.currentImageIndex])
      }
    },
    deleteCurrentImage(item, index) {
      this.$delete(this.selectedList, index)
    },
    clearImages() {
      this.selectedList = []
    },
    showMore() {
      if (this.isShowMore) {
        this.isShowMore = false
      } else {
        this.isShowMore = true
      }
    },
    // 报告上传
    sendReport() {
      let that = this
      uploadReport({
        image_conclusion: that.reportInfo.image_conclusion,
        image_performance: that.reportInfo.image_performance,
        image_url: that.selectedList.toString(),
        order_sn: that.reportInfo.order_sn
      }).then(response => {
        if (response.code === 1000) {
          this.$alert('您已成功出具报告', '成功', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push({ 'name': 'Home', params: { type: 1 } })
            }
          })
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // pdf上传
    sendPdf() {
      this.$refs.upload.submit();
      this.$message
      // let that = this
      // uploadPdf({

      // })
    },//上传成功
    // 3Dimg上传
    sendImg() {
      this.$refs.Imgupload.submit();
      this.$message
      // let that = this
      // uploadPdf({

      // })
    },//上传成功
    fileUploadSuccess(response) {
      //提示信息
      if(response.code == 1000){
        this.loading = false
      this.$message({
        type: 'success',
        message: '报告上传成功'
      })}
      if(response.code == 1001){ 
        this.loading = false
      this.$message({
        type: 'error',
        message: response.msg ,
      })}
    },
    //上传失败
    fileUploadError() {
      this.loading = false
      this.$message({
        type: 'error',
        message: '报告上传失败'
      })
    },
    /**
       * 报告文件删除回调
       */
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    /**
       * 图像文件删除回调
       */
       handleImgRemove(file, imgfileList) {
      this.imgfileList = imgfileList;
    },

    /**
     * 选择报告文件时回调
     */
    handlChange(file, fileList) {
      this.fileList = fileList;
    },
    /**
     * 选择图像文件时回调
     */
     handlImgChange(file, imgfileList) {
      this.imgfileList = imgfileList;
    },
    /**
     * 文件提交回调
     * @param data
     */
    myUploadFile(data) {
      let file = data.file;
      let formData = new FormData();
      formData.append("file", file);
      const loading = this.$loading({
        lock: true,
        text: '订单导入中',
      });
      importorder(formData).then(res => {
        loading.close();
        this.submitLoading = false;
        this.$confirm('', '导入成功', {
          confirmButtonText: '确定',
          type: 'success',
          showCancelButton: false,
          closeOnClickModal: false,
          center: true
        })
      }).catch(() => {
        loading.close();
        this.submitLoading = false;
      })
    },

    /**
     * 导入报告按钮触发
     */
    submitUpload() {
      this.submitLoading = true
      if (this.fileList.length <= 0) {
        this.$message.error("请先选择上传文件")
        this.submitLoading = false;
        return;
      }
      //触发 el-upload上传
      this.$refs.upload.submit(); //如果:http-request=""指定了回调函数,则会覆盖默认的上传,会流入到http-request的回调中
    },
    /**
     * 导入图片按钮触发
     */
     submitImgUpload() {
      this.submitLoading = true
      if (this.imgfileList.length <= 0) {
        this.$message.error("请先选择上传文件")
        this.submitLoading = false;
        return;
      }
      //触发 el-upload上传
     //如果:http-request=""指定了回调函数,则会覆盖默认的上传,会流入到http-request的回调中
      this.$refs.Imgupload.submit();
    },
    /**
     * 超出上传个数回调
     */
    handlExceed() {
      this.$message.error("只能选择一个文件进行上传")
    },
    // 接单
    getOrder: function () {
      let that = this
      getOrder({
        expert_id: that.$store.getters.getUser.account,
        order_sn: that.orderSn,
        type: that.orderType
      }).then((response) => {
        if (response.code === 1000) {
          this.$alert('接单成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              that.nowIsEdit = true
            }
          })
        } else {
          this.$message.error('请求数据失败')
        }
      })
    },
    // 报告转审
    transOrder() {
      let that = this

      this.$confirm('转审之后编辑的内容将被清空, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        transOrder({
          expert_id: that.$store.getters.getUser.account,
          order_sn: that.orderSn,
          type: that.orderType
        }).then((response) => {
          if (response.code === 1000) {
            this.$alert('转审成功', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                if (this.getIsPreView) {
                  this.$router.push({ 'name': 'Home', params: { type: 0 } })
                  return
                }
                this.$router.push({ 'name': 'Home', params: { type: 1 } })
              }
            })
          } else {
            this.$message.error(response.msg)
          }
        })
      }).catch(() => {
      })
    },
    //报告退还
    refundOrder () {
      let that = this
      that.$confirm('请选择接下来的操作?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认退款',
        cancelButtonText: '取消退款',
        type: 'warning'
      }).then(() => {
        refundOrder({
          orderSn: that.orderSn,
        }).then(resp => {
          if (resp.code === 1000) {
            this.$alert('退款成功', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                if (this.getIsPreView) {
                  this.$router.push({ 'name': 'Home', params: { type: 0 } })
                  return
                }
                this.$router.push({ 'name': 'Home', params: { type: 1 } })
              }
            })
          } else {
            this.$message.error(resp.msg)
          }
        })
      })
    },
  }
}
</script>

<style scoped>
.main {
  height: 100%;
  display: flex;
}

@media (max-width: 900px) {
  .main {
    width: 100%;
    height: 100%;
    background-color: black;
    overflow: hidden;
  }
}

.left {
  position: relative;
  flex: 3;
  overflow: hidden;
  background-color: black;
}

@media (max-width: 900px) {
  .left {
    width: 100%;
    height: 100%;
    background-color: black;
    overflow: hidden;
  }
}

.swiper-container .swiper-wrapper .swiper-slide {
  text-align: center;
  margin-top: 60px;
}

@media (max-width: 900px) {
  .swiper-container .swiper-wrapper .swiper-slide {
    text-align: center;
    margin-top: 60px;
  }
}

@media (min-width: 900px) {
  .swiper-container .swiper-wrapper .swiper-slide img {
    height: 800px;
  }
}

@media (max-width: 900px) {
  .swiper-container .swiper-wrapper .swiper-slide img {
    width: 100%;
  }
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal>.swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  color: white;
  font-size: 20px;
  bottom: 25px;
}

.right {
  flex: 1;
}

@media (max-width: 900px) {
  .right {
    display: none;
  }
}

.add-button {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 2;
}

@media (max-width: 900px) {
  .add-button {
    display: none;
  }
}

.right-title {
  line-height: 50px;
  text-align: center;
  border-bottom: 1px solid #dcdcdc;
  position: relative;
  height: 5%;
}

.title-left {
  position: absolute;
  left: 15px;
  cursor: pointer;
}

.title-right {
  position: absolute;
  right: 15px;
  display: inline-block;
}

.title {
  font-weight: bold;
  font-size: 17px;
  color: #409EFF;
}

.right-box {
  padding: 15px;
  border-bottom: 1px solid #dcdcdc;
}

.right-box-record {
  padding: 20px;
  border-bottom: 1px solid #dcdcdc;
}

.right-img-pic span {
  font-weight: bold;
  font-size: 17px;
  color: #409EFF;
}

.patient-msg {
  display: block;
  margin-bottom: 5px;
}

.more-msg {
  display: block;
  color: #3381FF;
  text-align: center;
  cursor: pointer;
}

.right-box-img {
  padding: 15px;
  border-bottom: 1px solid #dcdcdc;
  height: 8%;
}

.right-box-title {
  margin-bottom: 10px;
  position: relative;
}

.refund-btn{
  color: #fdfdfd;
  background-color: #868485;
  border-color: #8f8f8f;
 }
 .refund-btn:hover {
 background-color: #FE83C6; border-color: #FE83C6; 
 }

 .refund-btn:focus { 
  background-color:  #67c23a;
  border-color:  #67c23a;
 }

.imageDisplay {
  height: 85%;
  overflow: scroll;
  overflow-x: hidden;
}

.imageDisplay ul {
  padding: 0px;
  text-align: center;
}

.imageDisplay li {
  position: relative;
  list-style: none;
  display: inline-block;
  width: 25%;
  margin: 0 10px;
  height: 140px;
  overflow: hidden;
}

.imageDisplay img {
  width: 100%;
}

.el-icon-circle-close {
  position: absolute;
  color: red;
  right: 0px;
  top: 0px;
  font-weight: bold;
  cursor: pointer;
  font-size: 20px;
}

.el-radio {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}

.right-button {
  position: relative;
}

.button-two {
  position: fixed;
  bottom: 10px;
  right: 10px;
}

/* 历史列表样式 */
.history-list {
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  padding: 0 10px;
  overflow: hidden;
  overflow-y: auto;


  .history-list-box {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #FFFFFF;

    .history-left-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .item-name {
        font-size: 16px;
        font-weight: 500;
        color: #101010;
        margin-bottom: 4px
      }

      .item-date {
        font-size: 14px;
        color: #888888;
      }
    }

    .history-right-box {
      width: 60px;
      height: 25px;
      background-color: #3381FF;
      color: #FFFFFF;
      font-size: 16px;
      text-align: center;
      line-height: 25px;
      border-radius: 6px;
      cursor: pointer;
    }
    .history-right-close{
      width: 60px;
      height: 25px;
      background-color: pink;
      color: #FFFFFF;
      font-size: 12px;
      text-align: center;
      line-height: 25px;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}

.contrast-swiper-box {
  position: relative;
  flex: 3;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: black;

  .swiper-left-box {
    width: 600px;
  }

  .swiper-right-box {
    width: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/EditReport.vue